<i18n>
{
  "no": {
    "errorHeading": "En feil har oppstått ved innlogging",
    "errorDescription": "Siden fungerer ikke uten klient sertifikat."
  },
  "en": {
    "errorHeading": "Oh no! We weren't able to log you in",
    "errorDescription": "This page does not work without client certificate."
  }
}
</i18n>

<template>
  <InfoScreen>
    <TnHeading type="h1" size="s" class="margin-bottom-l">{{ t('errorHeading') }}</TnHeading>
    <TnNotificationInline horizontal status="critical" full-width>
      <span class="pre-line">{{ t('errorDescription') }}</span>
    </TnNotificationInline>
  </InfoScreen>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { TnHeading, TnNotificationInline } from '@telenornorgeinternal/telegrafen-vue3-core';

import InfoScreen from '@/components/InfoScreen.vue';

// useI18n() binds the local <i18n> block; $t/$i18n would resolve globally.
const { t } = useI18n();
</script>

<style scoped>
.pre-line {
  white-space: pre-line;
}
</style>
